import { c as _c } from "react/compiler-runtime";
import { createFileRoute } from "@tanstack/react-router";
import { ExperiencesView } from "@/lib/features/ExperiencesView";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_public/upplevelser/")({
  component: ExperiencesIndexPage
});
function ExperiencesIndexPage() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(ExperiencesView, {});
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}